export default __webpack_public_path__ + "static/media/superlike.1017adeb.svg";